/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Brand-videocam': {
    width: 26,
    height: 26,
    viewBox: '0 0 26 26',
    data: '<path pid="0" d="M18.417 11.375V7.583c0-.596-.488-1.083-1.084-1.083h-13c-.596 0-1.083.487-1.083 1.083v10.834c0 .595.487 1.083 1.083 1.083h13c.596 0 1.084-.488 1.084-1.083v-3.792l4.333 4.333V7.042l-4.333 4.333z" _fill="#00204D" opacity=".5"/>'
  }
})
